<template>
  <div>
    <div id="pageloading"></div>
    <div id="topmenu" class="l-topmenu">
        <div id="configurationDutton" v-if="ButtonsShow" @click="clickConfigurationDutton"><img :src="buttonData.imgpath" style="width: 136px;margin-top: -4px;margin-right: 5px;vertical-align: middle;" /></div>
        <div roleid="q309" class="l-topmenu-ad" v-if="tmscode!='92890' && tmscode != '98002' && !grayLevelShow && !isC9BSCallCar"  :style="{left:(ButtonsShow?'573px':'510px')}">
            <i class="l-icon l-icon-notice gbicon"></i>
            <div class="gonggao-num">[<span id="gonggao-num"></span>]</div>
            <div id="scrollobj">
                <ul></ul>
                <div class="hiddendiv"></div>
            </div>
        </div>
        <div class="l-topmenu-welcome" v-if="isTopMenuShow && !hasBindCYS">
            <div v-show="weCom && tmscode !='98002'" class="menu-item-nohover wxService" id="wxService" style="color:#fefefe;line-height:14px;">
                <img src="https://imagecdn.ymm56.com/ymmfile/static/resource/deafc4f1-a8b8-4468-b625-424a8a64987c.png" style="width:30px;height: 30px" />
                <p style="text-decoration: underline;margin-left: 5px">{{ weCom && weCom.title  || ''}}</p>
            </div>
            <div v-if="tmscode === '79932'" roleid="" class="menu-item-nohover" style="color:#fefefe;line-height:30px;">
                <img src="https://imagecdn.ymm56.com/ymmfile/static/resource/Images-24tel.png" style="width:34px;margin-top: -4px;margin-right: 5px;vertical-align: middle;" />
                <span style="color: #19B955; font-size: 14px">全国客服热线：400-836-0568</span>
            </div>

            <div v-if="tmscode != '98002'" roleid="q309" class="menu-item-nohover" style="color:#fefefe;line-height:14px;">
                <img src="https://imagecdn.ymm56.com/ymmfile/static/resource/Images-24tel.png" style="width:34px;margin-top: -4px;margin-right: 5px;vertical-align: middle;" />服务顾问<br><span id="click-server-func" onclick="clickServer()">{{tmsbsnewsreaders}}</span>
            </div>
            <div class="menu-item" v-if="!isC9BSCallCar">
                <div title="任务列表"><a class="l-link-item" id="task_list">
                    <img class="menu-item-icon task_list_png" src="https://imagecdn.ymm56.com/ymmfile/static/resource/Images-task_list.png"></a></div>
            </div>
            <div class="menu-item" roleid="c130405" v-if="!isC9BSCallCar">
                <div title="改单申请"><a class="l-link-item" id="gdsq_div"><i class="menu-item-icon l-icon-xiugai"></i></a></div>
            </div>
            <div class="menu-item" roleid="a1302" v-if="!isC9BSCallCar">
                <div title="快速开单"><a class="l-link-item" id="kskd_div"><i class="menu-item-icon l-icon-bulu"></i></a></div>
            </div>
            <div class="menu-item weComInsurance"  @click="changeInsuranceStatus">
                <img src="https://imagecdn.ymm56.com/ymmfile/static/resource/4cbacc55-325c-481b-a7ab-cbe340ec8ca5.png" style="width:28px;height: 28px"/>
                <div class="insurance-tip" v-if="isInsuranceShow && insuranceConsultation">{{insuranceConsultation.title}}
                    <div class="insurance-triangle"></div>            
                </div>
            </div>

            
            <div class="menu-item more-menu-item" style="position: relative;z-index:100;" v-if="tmscode!=92890 && !isC9BSCallCar">
                <div><a class="l-link-item" id="查看更多"><i class="menu-item-icon l-icon-menu"></i></a></div>
          <div class="menu-item-list">
            <div class="menu-item-list-div">

                <div v-if="tmscode == '96908' || tmscode == '82635'">
                    <img @click.stop="openOrderNumChart" src="https://imagecdn.ymm56.com/ymmfile/static/resource/Images-bigData.png" title="单量业务趋势图" alt="单量业务趋势图" style="width: 24px;height:24px;">
                </div>

                <div v-if="tmscode == '96908' || tmscode == '82635'">
                    <img @click="openCarChart" src="https://imagecdn.ymm56.com/ymmfile/static/resource/Images-bigData.png" title="在途车辆分布图" alt="在途车辆分布图" style="width: 24px;height:24px;">
                </div>

                <div v-if="tmscode != '96908'" roleid="q309" id="bi">
                    <div title="大数据">
                        <a class="l-link-item dashuju" data-tabid="156" data-text="大数据中心" style="background:#fff;width:100%;height:100%;display:block;" href="https://t9bs_echart.lqfast.com/Charts/index.html?parstr=" target="_blank">
                            <img src="https://imagecdn.ymm56.com/ymmfile/static/resource/Images-bigData.png" alt="" style="width: 24px;height:24px;">
                        </a>
                    </div>
                </div>
                <div roleid="" class="downapp">
                      <img src="https://imagecdn.ymm56.com/ymmfile/static/resource/Images-mobilePhone.png" alt="" style="width: 24px;height:24px;">
                    <div class="downappcode">
                        <div style="height: 100%;border-radius: 12px;">
                            <img :src="lq_cdn_t9bs + '/Images/sm_bg.png'" alt="" style="width: 100%;height: 100%;">
                            <div class="miniapp-qrcode" v-if="isEnableLandingDispatch">
                                <div id="miniapp-share-img"></div>
                                蓝桥广达专线司机管理版
                            </div>
                        </div>
                    </div>
                </div>
                <div class="contactWay" style="position: relative;" roleid="q309">
                    <img src="https://imagecdn.ymm56.com/ymmfile/static/resource/Images-insurance.png"  style="width: 24px;height:24px;">
                        <div class="contactWayCode" :style="tmscode=='92890'?'height: 60px;':''">
                            <div style="height: 100%;border-radius: 12px; overflow: hidden;">
                                <div class="contactWayCodeOne">
                                    <span><img src="https://imagecdn.ymm56.com/ymmfile/static/resource/Images-bxtel.png" style="width:14px;margin-top: -4px;margin-right: 5px;vertical-align: middle;" />保险热线</span> 13430245392
                                </div>
                                <div class="contactWayCodeOne" v-if="tmscode=='92890'">
                                    <span ><img src="https://imagecdn.ymm56.com/ymmfile/static/resource/Images-bxtel.png" style="width:14px;margin-top: -4px;margin-right: 5px;vertical-align: middle;" />服务顾问</span>{{tmsbsnewsreaders}}
                                </div>
                            </div>
                        </div>
                </div>
                <div>
                    <img onclick="openpPayScanCode()" src="https://imagecdn.ymm56.com/ymmfile/static/resource/Images-CollectionByScanningCode.png"  title="扫码收款 免费开通" alt="扫码收款 免费开通" style="width: 24px;height:24px;">
                </div>
            </div>
          </div>
        </div>
            <div class="menu-item news-outer" style="display:none;">
                <div title="消息">
                    <a class="l-link-item shake-rotate" data-tabid="newstabid" data-text="消息" data-url="/Common/Matter" style="width:100%;height:100%;display:block;position:relative;">
                        <i class="menu-item-icon l-icon-news"></i>
                        <span class="news-nums"></span>
                    </a>
                </div>
            </div>

            <div class="menu-item quickFindBody" v-if="!isC9BSCallCar">
                <input type="text" id="quickFindVals" placeholder="请输入任意关键字查询" maxlength="18" />
                <div class="kz-ss" id="quickFindBtn"></div>
                <div class="quickSearch-bar"></div>
                <div class="quickSearch-settings quickSearch-icon l-icon l-icon-settings" title="设置搜索关键字"></div>
                <div class="quickSearch-listBtn quickSearch-icon l-icon l-icon-menu" title="打开查询下拉条件"></div>
                <div class="quickSearch-settings-box">
                    <div class="qs-title">设置下拉条件选择<span>(勾选显示，按从上到下排序)</span></div>
                    <div class="qs-set-left"></div>
                    <div class="qs-set-right">
                        <div class="qs-btn" type="prev">向上</div>
                        <div class="qs-btn" type="next">向下</div>
                        <div class="qs-btn" type="sure">确定</div>
                        <div class="qs-btn" type="candle">取消</div>
                    </div>
                </div>
            </div>
            <div class="menu-item help-body" style="display:none;">
                <div title="帮助"><a><i class="menu-item-icon l-icon-help"></i></a></div>
                <div class="hide-menu other-tool">
                    <ul>
                        <li style="border-bottom:1px solid #ddd;padding:10px 5px;">
                            <a class="l-link-item" data-tabid="1302" data-text="公司公告" data-url="/Notice/Index">
                                <img src="https://imagecdn.ymm56.com/ymmfile/static/resource/Images-notice.png" />
                                <span>公司公告</span>
                            </a>
                        </li>
                        <li style="border-bottom:1px solid #ddd;padding:10px 5px;">
                            <a class="l-link-item" data-tabid="updateRecord" data-text="更新记录" data-url="/updateRecord/Index">
                                <img src="https://imagecdn.ymm56.com/ymmfile/static/resource/Images-update.png" />
                                <span>更新记录</span>
                            </a>
                        </li>
                        <li style="border-bottom:1px solid #ddd;padding:10px 5px;">
                            <a class="l-link-item" data-tabid="zyDownload" data-text="资源大本营" data-url="/zyDownload/Index">
                                <img src="https://imagecdn.ymm56.com/ymmfile/static/resource/Images-update.png" />
                                <span>资源大本营</span>
                            </a>
                        </li>
                        <li style="border-bottom:1px solid #ddd;padding:10px 5px;">
                            <a class="l-link-item" data-tabid="ProblemsLibrary" data-text="解决方案大本营" data-url="/zyDownload/ProblemsLibrary">
                                <img src="https://imagecdn.ymm56.com/ymmfile/static/resource/Images-wt.png" />
                                <span>解决方案大本营</span>
                            </a>
                        </li>
                        <li style="padding-top:10px;cursor:default !important;">
                            <a>
                                <img src="https://imagecdn.ymm56.com/ymmfile/static/resource/Images-wt.png" />
                                <span style="text-decoration:none !important;">常见问题</span>
                            </a>
                        </li>
                        <li onclick="openPrintWin()" style="text-indent:60px;"><span>打印故障排查</span></li>
                        <li onclick="openPrintWin()" style="text-indent:60px;"><span>建议分辨率</span></li>
                        <li onclick="showShortcutsBody()" style="text-indent:60px;"><span>全局快捷键</span></li>
                    </ul>
                </div>
            </div>
            <div class="menu-item help-body" style="display:none;">
                <div title="皮肤" id="skin-tit"><a><i class="menu-item-icon l-icon-skin"></i></a></div>
                <div class="hide-menu other-tool skin-menu">
                    <ul>
                    </ul>
                </div>
            </div>
        </div>
        <div class="toggle" id="LANToPrintBtn">
            <input type="checkbox" class="check" name="openLANToPrint" id="openLANToPrint" title="局域网打印">
            <b class="b switch"></b>
            <b class="b track"></b>
            <span class="toggle-txt toggle-txt-close">关</span>
            <span class="toggle-txt toggle-txt-open">开</span>
            <span class="toggle-txt toggle-txt-error">断</span>
            <div class="LANinfo">
                <p>当前蓝桥局域网打印状态：<span class="lanType">未开启</span></p>
                <p>当前客户端局域网IP为：<span class="localIP"></span></p>
                <p class="lan-tips">您的管理员未开启默认局域网打印，您可暂时开启，但重新登录后仍会自动关闭。</p>
            </div>
        </div>
    </div>
    <!-- 系统右下角消息框 -->
    <div id="rightBottomWin">
        <div class="winHeader">新消息提醒 <span class="winHeaderBtn">X</span></div>
        <div class="winBody">
        </div>
    </div>
    <!-- 点击消息框显示的大弹窗 -->
    <div class="detailBody">
        <div class="maskWin"></div>
        <div class="closeWinBtn">X</div>
        <div id="showDetail">
            <div class="zxtel">咨询热线：400-830-3721</div>
            <!-- 填写信息 -->
            <div class="formInfo">
                <div class="formInfoHead">免费申请/对接GPS</div>
                <div id="trywarn" style="color:red"></div><br />
                <label>公司名称</label><input id="corporateName" type="text" /><br />
                <label>企业ID</label><input id="companyId" type="text" /><br />
                <label>&emsp;联系人</label><input id="contacts" type="text" /><br />
                <label>联系电话</label><input id="contactTel" type="text" /><br />
                <button onclick="applyGps()">确定申请</button>
            </div>
        </div>
    </div>

    <!-- 快捷键侧边栏 -->
    <div class="shortcutsBody">
        <div class="maskWin"></div>
        <div id="shortcuts-content">
            <div class="closeWinBtn">X</div>
            <div>
                <div class="title">全局操作快捷键</div>
                <div class="content">
                    <ul>
                        <li><div>动作</div><div>快捷键</div></li>
                        <li><div>新增</div><div>Ctrl+F1</div></li>
                        <li><div>修改</div><div>Ctrl+F2</div></li>
                        <li><div>保存</div><div>F4</div></li>
                        <li><div>删除</div><div>F6</div></li>
                        <li><div>保存并打印</div><div>F9</div></li>
                        <li><div>退出</div><div>Esc</div></li>
                        <li><div>提取</div><div>Ctrl+空格键</div></li>
                        <li><div>导出</div><div>Ctrl+D</div></li>
                        <li><div>表格设置</div><div>Ctrl+S</div></li>
                        <li><div>锁定外观</div><div>Ctrl+L</div></li>
                        <li><div>快找</div><div>Ctrl+F</div></li>
                        <li><div>选中文字</div><div>Ctrl+A</div></li>
                        <li><div>剪切复制</div><div>Ctrl+X</div></li>
                        <li><div>复制</div><div>Ctrl+C</div></li>
                        <li><div>黏贴</div><div>Ctrl+V</div></li>
                        <li><div>浏览器恢复100%</div><div>Ctrl+0(零)</div></li>
                        <li><div>快速开单</div><div>Ctrl+1(一)</div></li>
                    </ul>
                </div>
            </div>
        </div>
    </div>


    <!-- 全屏banner -->
    <div id="banner-outer">
        <div class="maskWin"></div>
        <div class="closeWinBtn">X</div>
        <div class="banner-content">
        </div>
    </div>

    <div class="ad-banner">
        <div class="maskWin"></div>
        <div class="closeWinBtn2">X</div>
        <div class="ad-banner-btn-notips">不再提示</div>
        <div class="closeWinBtn2">X</div>
        <div class="swiper-container">
            <div class="swiper-wrapper"></div>
            <div class="swiper-pagination"></div>
        </div>
    </div>

    <div class="update-dialog-wraper">
        <div class="maskWin" style="position: absolute;"></div>
        <div class="update-dialog">
            <div class="content">
                <p class="title" style="font-size: 20px;">新消息提示</p>
                <div class="update-box" style="text-align: center; margin-top: 10px;">
                    <p class="count"></p>
                </div>
            </div>
            <div class="footer">
                <button class="cancel close" style="display: none;">忽略</button>
                <button class="read close">查阅</button>
            </div>
        </div>
        <!-- 未读公告 -->
        <div class="un-read-wrap">
        </div>
    </div>

    <!-- 移动端下载提示 -->
    <div class="app-down-outer" style="display: none;">
       <div class="maskWin" style="background: rgba(100,100,100,0.8)"></div>
    <!-- 操作指引 -->
    <div class="app-down-arrow-tip">
        <div class="lq-arrow-top"></div>
        <div class="lq-tip-content">
            <div class="lq-tip-title">
                <i class="l-icon l-icon-notice"></i>好消息！蓝桥人工客服上线了！
            </div>
            <div class="lq-tip-text">
                点击客服图标 <img class="lq-tip-customer" src="https://imagecdn.ymm56.com/ymmfile/static/resource/Images-zxkf.png" alt=""> 立刻开始微信沟通！
            </div>
            <div class="lq-tip-p">
                <strong style="font-weight: 600;">·</strong> 系统功能不会用？专业团队为您详细解答困惑！
            </div>
            <div class="lq-tip-p">
                <strong style="font-weight: 600;">·</strong> 使用过程出错误？贴心客服帮您及时反馈问题！
            </div>
            <div class="lq-tip-bottom">
                <div class="lq-tip-btn" id="lq-tip-close">知道了</div>
                <div class="lq-tip-bottom-text">
                    人工客服时间：工作日 上午9:00-12:00 下午14:00-18:00<br/>
                    (需本电脑已安装微信客户端<i style="color: #24db5a;margin:0 4px;" class="l-icon l-icon-weixin"></i>)
                </div>
            </div>
        </div>

    </div>
</div>


    <!-- 微信分享二维码弹窗 -->
    <div id="lq-share-codeimg">
        <div class="lq-share-title">运单号：<span id="lq-share-unit"></span></div>
        <div id="lq-share-box">
            <div id="lq-share-img"></div>
            <div id="lq-share-empty" onclick="lqShareUnitClass.toCreadCodeImg()" >
                <i class="l-icon-refresh"></i>
                点击重新生成
            </div>
        </div>
        <div class="lq-share-tip">使用手机微信“扫一扫”，快速查询运单物流</div>
        <span id="lq-share-link"></span>
        <a href="javascript:;" style="font-size: 16px;" onclick="lqShareUnitClass.toCopyShareLink()">复制链接</a>
    </div>
    <!-- 催款客户信息列表 -->
    <div id="online-prompt-outer" style="display:none">
        <div id="online-prompt-grid"></div>
    </div>
    <div id="online-prompt-detail-outer">
        <div id="online-prompt-detail-grid"></div>
    </div>

  </div>
</template>

<script>
import { includeScriptListOrdinal } from '@/utils/common'
import { SCRIPT_BASEURL } from '@/utils/enum'
import { createDialog } from '@meta-vue/create-dialog'
import ServicerDialog from '@/views/srvicerDialog/index.vue'
export default {
  name: 'HeaderComponent',
  props: {
    hasBindCYS: {
        default: false,
        type: Boolean
    }
  },
  data () {
      return {
        isTopMenuShow: !sessionStorage.getItem('proxyOperateKey'),
        grayLevelShow:false,
        baseUrl:window.location.host=='t9bs.lqfast.com' || window.location.host=='t9bsjcqa.lqfast.com'?'https://internal-marketing.lqfast.com':'https://internal-marketing-dev.lqfast.com',
        tmscode: getNewUserInfo().TMSCode,
        tmsbsnewsreaders: $.cookie('tmsbsnewsreaders'),
        lq_cdn_t9bs: window.__lq_assets_base_url,
        buttonData:{},
        ButtonsShow:false,
        weCom: JSON.parse(localStorage.getItem('configMap') || '{}') &&  JSON.parse(localStorage.getItem('configMap') || '{}').weCom,
        insuranceConsultation: JSON.parse(localStorage.getItem('configMap') || '{}') &&  JSON.parse(localStorage.getItem('configMap') || '{}').insuranceConsultation,
        isInsuranceShow: false,
        isC9BSCallCar: $.getcookie('TMSversion') === window.LQAPI.C9BS_CALL_CAR,
        isEnableLandingDispatch: localStorage.getItem("isEnableLandingDispatch") == '1',
      }
  },
  mounted () {
    window.header_vm = this
    try {
        $.javaAjax({
          url: "/special-line-help/is-grey-user",
          type: "POST",
          success:  (result) =>{
            if (result.success&& result.data) {
                this.grayLevelShow=true
            }else{
                this.grayLevelShow=false
            }
           },
        })
    } catch (error) {
        this.grayLevelShow=false
    }

    includeScriptListOrdinal([
      SCRIPT_BASEURL + '/data/SMSUserCode.js',
      SCRIPT_BASEURL + '/qrcode.min.js',
      SCRIPT_BASEURL + '/shared/header.js',
      SCRIPT_BASEURL + '/ScriptsPage/base64.js'
    ])
    var tt = setTimeout(() => {
        clearTimeout(tt)
        window.lib && window.lib.track.view('info_insuranceAdvisor', 'Func', {
            pageName: 'lanqiao_saas_home'
        })
        window.lib && window.lib.track.view('enter_WChat', 'Main', {
            pageName: 'lanqiao_saas_home'
        })
    }, 1250);
  },
  beforeDestroy() {
    delete window.header_vm
  },
  methods:{
    openServicerDialog() {
        const [name, phone] = this.tmsbsnewsreaders&&this.tmsbsnewsreaders.split('/');
        const vm = createDialog(
            ServicerDialog,
            {
                name: name,
                phone: phone,
                onClose: () => {
                    vm.hide()
                }
            },
            {
                title: '服务顾问 - 企业ID：' + getCookie("tmscode") ,
                width: '480px',
                'close-on-click-modal': false
            }
        )
        vm.show()
    },
    openOrderNumChart() {
      top.f_addTab("OrderNumChart", "单量业务趋势图", "/NewChart/OrderNumChart")
    },
    openCarChart() {
      top.f_addTab("CarChart", "在途车辆分布图", "/NewChart/CarChart")
    },
    changeInsuranceStatus () {
        this.isInsuranceShow = !this.isInsuranceShow
        window.lib && window.lib.track.tap('info_insuranceAdvisor', 'Func', {
            pageName: 'lanqiao_saas_home'
        })
    },
    privacyShow(){
        this.$emit("privacyButtons")
    },
    clickConfigurationDutton(){
        this.getSaveBurypoint(this.buttonData.project,this.buttonData.projectid,'点击事件')
        let verifyFinish = this.buttonData.verifyFinish.split(",");
        let getNewUserIn = getNewUserInfo()
        let openurl = this.buttonData.openurl
        let prefix ='&'
        if(openurl.indexOf('?')==-1){
          prefix='?'
        }
        for (let index = 0; index < verifyFinish.length; index++) {
            let element = verifyFinish[index]
            if(index==0){
              openurl+=prefix
            }else{
              openurl+='&'
            }
            if(element =='companyid'){
              openurl+=('companyid='+this.buttonData.companyid)
            }else{
              openurl+=(element+'='+getNewUserIn[element])
            }
        }
        if(verifyFinish.length!=0){
          openurl+='&Token='+getNewUserIn.Token+'&source='+'T9BS'
        }else{
          openurl+=(prefix+'Token='+getNewUserIn.Token+'&source='+'T9BS')
        }
        if(this.buttonData.opentype!=0){
          window.open(openurl);
        }
    },
    getSaveBurypoint (project,projectid,point){
      $.ajax({
        url: this.baseUrl+`/api/AdvertApi/SaveBurypoint?project=${project}&projectid=${projectid}&point=${point}`,
        data: {},
        method: 'post',
        beforeSend: function (request) {
            request.setRequestHeader("source", 'T9BS');
        },
        success: function (res) {
 
        },
        complete: function (){
 
       }
      })
    },
    InitializeButtons(obj){
        this.buttonData=obj
        this.ButtonsShow=this.buttonData.ifShow || false
    }
  }
}
</script>

<style>
        .onLineService{
            position: relative;
        }
        .onLineServicePopup{
        display: none;
        position: absolute;
        right: -204px;
        top: 58px;
        width: 395px;
        height: 221px;
        padding-top: 8px;
        background: #fff;
        z-index: 100;
        border-radius: 12px;
        }
     .onLineServicePopup::after {
      content: "";
      width: 0;
      height: 0;
      border: 20px solid;
      position: absolute;
      top: -40px;
      left: 156px;
      border-color: transparent transparent #fff transparent;
    }
    .onLineServicePopupImg{
      display: flex;
      /* float: left; */
    }
    .onLineServicePopupHeadline{
      font-family: AlibabaPuHui;
      font-size: 14px;
      font-weight: 400;
      color: rgb(109, 103, 103);
      font-style: normal;
      text-align: center;
      display: flex;
      justify-content: center;
      align-items: center;
     
    }
    .onLineServicePopupRight{
      width: 179px;
      height: 114px;
      border: 5px solid transparent;
      border-radius: 10px;
      background: #fff; 
      background-clip: padding-box;
      position: relative;
      text-align: center;
    }
    .onLineServicePopupRight::before {
      content: '';
      position: absolute;
      top: 0;
      right: 0;
      left: 0;
      bottom: 0;
      z-index: -1;
      margin: -5px;
      border-radius: 10px;
      background: linear-gradient(to right, #a5adf0, #dec6ed);
    }
    .onLineServicePopupRightDutton{
      width: 155.03px;
      /* margin-left: 36px; */
      margin: 0 auto;
      margin-top: 10px;
      height: 25.75px;
      font-family: AlibabaPuHui;
      font-size: 12px;
      font-weight: 400;
      display: flex;
      align-items: center;
      justify-content: center;
      color: #fff;
      border-radius: 5px;
      background: linear-gradient(to right, #a5adf0, #dec6ed);
    }
    .onLineServicePopupRightTime{
      /* margin-top: 17px; */
      padding-top: 3px;
      margin: 0 auto;
      display: flex;
      align-items: center;
      width: 155.03px;
      justify-content: center;

    }
    .onLineServicePopupRightremark{
      display: flex;
      padding-top: 3px;
      align-items: center;
      justify-content: center;
      height: 20px;
    }
    #skinSelect {
        color: #999999;
    }


    .l-topmenu-logo {
        background-color: #00b150;
        box-shadow: 0 2px 23px 0;
    }

        .l-topmenu-logo img { /*width: 210px; height: 35px; */
            width: auto;
            height: 40px;
            margin-left: -34px;
        }

    label.comInfo {
        color: #666;
        position: absolute;
        top: 5px; /*left: 218px; */
        left: 118px;
        font-size: 16px !important;
    }

    a.headerBtn {
        font-family: PingFangSC-Regular;
        font-size: 16px;
        color: #fff;
        text-decoration: none;
        padding: 5px 0; /*border: 1px solid #dbdfeb; */
        border-radius: 2px;
        margin: 0 10px;
        background: #fff;
        text-align: center;
        vertical-align: middle;
        text-decoration: none;
        background-color: #00b150;
    }

    #cyfn {
        margin-left: 0;
    }

    .headerBtn:hover {
        background: rgba(255,255,255,0.03); /*border: 1px solid #45BFFF; */
        border-radius: 2px;
    }

    .headerBtn:active {
        opacity: 0.8;
        background: #F3F3F3;
        border: 1px solid #0166FF;
        border-radius: 2px;
    }
    #configurationDutton{
        /* display: none; */
        position: absolute;
        left: 426px;
        top: 20%;
        height: 25px;
        width: 136px;
        line-height: 25px;
        cursor: pointer;
        /* color: #ffff00;
        border: 1px solid #fff; */
        border-radius: 5px;
        text-align: center;
    }
    .l-topmenu-ad {
        position: absolute; /*left: 160px; */
        left: 510px;  /* 573px */
        top: 50%;
        height: 25px;
        width: 300px; /*margin-left: -95px; */
        margin-top: -12.5px;
        display: none;
    }
    .new-close-span {
        position: absolute;
        right: 4px;
        top: 0px;
        cursor: pointer;
        z-index: 1;
        font-size: 10px;
        height: 14px;
        line-height: 14px;
        text-align: right;
    }

    .gbicon {
        float: left;
        line-height: 25px;
        height: 25px;
        color: #0fa0e7;
    }

    #scrollobj {
        white-space: nowrap;
        color: #fff;
        overflow: hidden;
        width: 245px;
        height: 25px;
        margin: auto;
        display: block;
        margin-left: 2px;
        float: left;
        position: relative; /*position: fixed; left: 220px; top: 4px; */
    }

        #scrollobj ul {
            width: 100%;
            height: auto;
        }

    .loginInfoFont {
        color: #139fec;
        width: 100%;
        height: 25px;
        line-height: 25px;
        font-weight: 900;
        text-align: left;
        position: relative;
        cursor: pointer;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
    }

        .loginInfoFont:hover {
            color: #ffff00;
            text-decoration: underline;
        }
    
    /*微步以tab形式打开特殊处理*/
    .l-tab-content-item iframe {
        width: 100% !important;
        height: 100% !important;
        border: none !important;
        margin: 0 !important;
        padding: 0 !important;
    }

    #quickFindVals {
        width: 120px;
        height: 22px;
        float: left;
        line-height: 24px;
        border: 1px solid #dbdfeb;
        padding-left: 24px;
        padding-right: 60px;
        margin-top: 0px;
        background-color: #fff;
        border-radius: 20px;
        outline: none;
        font-size: 12px;
        font-weight: bold;
        -webkit-transition: all .25s ease;
        -moz-transition: all .25s ease;
        -ms-transition: all .25s ease;
        -o-transition: all .25s ease;
        transition: all .25s ease;
    }

        #quickFindVals:focus {
            border-color: #fff;
            box-shadow: 0 0 5px 3px #11baee;
            width: 240px;
            font-size: 16px;
        }

    .quickFindBody {
        float: left;
        margin: 3px 5px 0;
        min-width: 40px;
        text-align: center;
        padding: 0px 5px;
        position: relative;
    }

    .menu-big-item .shell-menu2 {
        background-color: #fff;
    }

    .headSculpture {
        width: 58px;
        height: 58px;
        border-radius: 50%;
        border: 1px solid #e9f9ff; /*background:#00b150; */
        margin: 15px;
        float: left;
    }

    .l-topmenu-welcome label {
        color: #000;
    }

    .l-topmenu-welcome .separators {
        float: left;
        color: #dbdfeb;
    }

    .menu {
        text-align: left;
        font-size: 14px;
    }

    .leaveDialog .l-dialog-winbtns {
        display: none;
    }

    .l-topmenu-welcome .menu-item {
        padding: 0;
        height: 30px;
    }


    .menu-item-nohover {
        float: left;
    }
    .wxService {
        margin-right: 20px;
        display: flex;
        align-items: center;
    }
    .weComInsurance {
        position: relative;
        z-index:30
    }
    .insurance-tip {
        background: #ffffff;
        width: 278px;
        height: 46px;
        border-radius: 8px;
        position: absolute;
        top: 40px;
        z-index: 30;
        left: -120px;
        text-align: center;
        font-size: 14px;
        font-weight: 500;
        color: #161616;
        line-height: 46px;
    }
    .insurance-triangle {
        position: absolute;
        top: -30px;
        z-index: 30;
        width: 0;
        height: 0;
        border-top: 20px solid transparent; 
        border-right: 20px solid transparent;
        border-left: 20px solid transparent;
        border-bottom: 20px solid #ffffff;
        left: 116px;
    }

    .addbtn {
        position: relative;
        width: 45px;
        height: 45px;
        border: 2px dashed #ffca08;
        left: 50%;
        margin-left: -22.5px;
        text-align: center;
        line-height: 45px;
    }

        .addbtn:after {
            content: "+";
            font-size: 32px;
            color: #ffca08;
        }

    .kz-sm {
        position: absolute;
        right: 40px;
        width: 20px;
        top: 2px;
        height: 20px;
        background: url(https://imagecdn.ymm56.com/ymmfile/static/resource/Images-saoys.png) no-repeat center center;
        background-size: 100%;
    }

    .kz-ss {
        position: absolute;
        right: 17px;
        top: 2px;
        width: 20px;
        height: 20px;
        background: url(https://imagecdn.ymm56.com/ymmfile/static/resource/Images-sousuo.png) no-repeat center center;
        background-size: 100%;
        cursor: pointer;
    }

    .help-body .hide-menu {
        left: auto;
        right: 0;
    }

    .menu-big-item .shell-menu1 {
        background: #f5f5f5;
        border: 1px solid #ddd;
    }

        .menu-big-item .shell-menu1 .small-menu1 {
            width: 100%;
            font-size: 14px; /*padding: 5px 0; */
            text-indent: 30px;
        }

            .menu-big-item .shell-menu1 .small-menu1.small-menu-title {
                text-indent: 15px;
                text-align: left;
                font-weight: bold;
                padding-top: 10px;
                font-size: 16px;
                color: #000;
                border-top: 1px solid #ddd;
            }

        .menu-big-item .shell-menu1 a {
            color: #555;
        }

    .other-tool {
        background: #f5f5f5;
        border: 1px solid #ddd;
    }

        .other-tool li {
            text-indent: 10px;
            width: 150px;
            font-size: 14px;
            color: #555;
        }

            .other-tool li a {
                color: #000;
            }

            .other-tool li img {
                width: 20px;
                height: 20px;
                vertical-align: middle;
                margin-top: -4px;
                margin-right: 10px;
            }

    .other-tool {
        padding-bottom: 15px;
    }

    .skin-menu {
        width: 100px;
    }

        .skin-menu li {
            width: 80%;
            margin: 0 auto;
            border-bottom: 1px solid #e2e1e1;
            position: relative;
            text-indent: 17px;
        }

        .skin-menu ul li:hover {
            color: #03A9F4;
            border-color: #03A9F4;
        }

        .skin-menu li.skin-selected {
            color: #03A9F4;
            border-color: #03A9F4;
        }

   
    #task_list .task_list_png{
        height: 28px;
        width: 28px;
    }
    .l-link-item .task_list_png,
    .l-icon-toubao, .l-icon-xiugai {
        line-height: 28px;
        font-size: 23px;
    }

    .l-icon-help, .l-icon-skin {
        font-size: 20px;
    }

    .l-icon-toubao {
        color: #d5f612;
    }

    .skin-menu li:after {
        content: "";
        width: 15px;
        height: 15px;
        position: absolute;
        left: 0;
        top: 7px;
        background: #1f4e78;
        display: block;
        box-shadow: 0px 0px 2px 0px rgba(0,0,0,0.5);
    }

    .skin-menu li[skinUrl="blackSkin"]:after {
        background: #2f4554;
    }

    .skin-menu li[skinUrl="blueSkin"]:after {
        background: #2775b6;
    }

    .skin-menu li[skinUrl="lydfSkin"]:after {
        background: #eea6b7;
    }

    .skin-menu li[skinUrl="glhSkin"]:after {
        background: #503e2a;
    }

    .skin-menu li[skinUrl="mgfSkin"]:after {
        background: #f8b37f;
    }

    .skin-menu li[skinUrl="mrjcSkin"]:after {
        background: #fa7e23;
    }

    .skin-menu li[skinUrl="yzhSkin"]:after {
        background: #f03f24;
    }

    .skin-menu li[skinUrl="mgzSkin"]:after {
        background: #ba2f7b;
    }

    .skin-menu li[skinUrl="mdlSkin"]:after {
        background: #12aa9c;
    }

    .skin-menu li[skinUrl="dlshSkin"]:after {
        background: #fafafa;
    }

    #rightBottomWin {
        position: fixed;
        right: 10px;
        bottom: 0;
        z-index: 9999;
        width: 300px;
        background: #fff;
        border: 1px solid #1f4e78;
        border-bottom: 0 none;
        border-radius: 6px 6px 0 0;
        display: none;
    }

    .winHeader {
        height: 30px;
        line-height: 30px;
        font-size: 16px;
        text-align: center;
        color: #fff;
        background: #1f4e78;
    }

    .winHeaderBtn {
        position: absolute;
        right: 10px;
        top: 0;
        cursor: pointer;
    }

        .winHeaderBtn:hover {
            color: red;
        }

    .winBody {
        width: 100%;
        height: 170px;
        cursor: pointer;
        background-repeat: no-repeat;
        background-position: center center;
        background-size: 80%;
    }

        .winBody img {
            width: 100%;
        }

    .detailBody {
        position: fixed;
        left: 0;
        top: 0;
        width: 100%;
        height: 100%;
        z-index: 10001;
        display: none;
    }

    .closeWinBtn,
    .closeWinBtn2,
    .closeButton {
        position: absolute;
        right: 50px;
        top: 50px;
        z-index: 10002;
        width: 30px;
        height: 30px;
        border-radius: 50%;
        line-height: 30px;
        font-size: 20px;
        color: #fff;
        background: red;
        text-align: center;
        cursor: pointer;
    }

    .closeButton{
      right: 30px;
      top: 60px;
    }

        .closeWinBtn:hover,
        .closeWinBtn2:hover,
        .closeButton:hover {
            opacity: 0.8;
        }

    .maskWin {
        width: 100%;
        height: 100%;
        background: rgba(0,0,0,0.8);
        cursor: pointer;
    }


        #showDetail img, .banner-content img {
            width: 100%;
            cursor: pointer;
        }

    .formInfo {
        padding: 15px;
        padding-top: 40px;
        position: absolute;
        left: 9%;
        bottom: 21%;
        background: rgba(255,255,255,0.8);
        border-radius: 3px;
        box-shadow: 0px 0px 10px 2px rgba(0,0,0,0.8);
    }

        .formInfo label {
            color: #666;
            width: 60px;
            text-align: right;
            display: inline-block;
        }

        .formInfo input {
            color: #666;
            border: 1px solid #ddd;
            margin-bottom: 10px;
            margin-left: 5px;
            width: 250px;
            height: 20px;
            line-height: 20px;
            text-indent: 10px;
            border-radius: 3px;
        }

        .formInfo button {
            width: 100%;
            border: 1px solid #03A9F4;
            cursor: pointer;
            background: #03A9F4;
            color: #fff;
            border-radius: 3px;
            height: 30px;
        }

            .formInfo button:hover {
                opacity: 0.8;
            }

    .formInfoHead {
        color: #666;
        text-align: center;
        position: absolute;
        width: 100%;
        top: 0;
        left: 0;
        height: 30px;
        line-height: 30px;
        font-size: 14px;
        border-bottom: 1px solid #fff;
    }

    .zxtel {
        position: absolute;
        top: 25%;
        left: 9%;
        font-size: 30px;
        color: red;
        font-weight: bolder;
    }

    .news-nums {
        background: red;
        position: absolute;
        left: 16px;
        font-size: 12px;
        top: -5px;
        padding: 4px;
        line-height: 12px;
        border-radius: 9px;
        color: #fff !important;
        font-weight: bolder;
    }

    .shortcutsBody, #banner-outer {
        position: fixed;
        width: 100%;
        height: 100%;
        z-index: 99999;
        top: 0;
        left: 0;
        display: none;
    }

    #shortcuts-content {
        position: absolute;
        right: 0;
        top: 0;
        width: 300px;
        height: 100%;
        background: #fff;
        padding: 24px;
        -webkit-box-sizing: border-box;
        -moz-box-sizing: border-box;
        box-sizing: border-box;
    }

        #shortcuts-content .closeWinBtn {
            right: 10px;
            top: 10px;
            background: none;
            color: #999;
        }

            #shortcuts-content .closeWinBtn:hover {
                color: red;
            }

        #shortcuts-content .title {
            font-size: 14px;
            color: rgba(0,0,0,.85);
            line-height: 22px;
            margin-bottom: 12px;
        }

        #shortcuts-content .content {
            border: 1px solid #eee;
            border-bottom: 0 none;
        }

            #shortcuts-content .content li {
                line-height: 30px;
                border-bottom: 1px solid #eee;
                overflow: hidden;
            }

                #shortcuts-content .content li:first-child {
                    background: #03A9F4;
                }

                    #shortcuts-content .content li:first-child div {
                        color: #fff;
                    }

                #shortcuts-content .content li div {
                    float: left;
                    text-indent: 10px;
                    color: #666;
                }

                    #shortcuts-content .content li div:first-child {
                        width: 100%;
                    }

                    #shortcuts-content .content li div:last-child {
                        width: 80px;
                        margin-left: -80px;
                        border-left: 1px solid #eee;
                        -webkit-box-sizing: border-box;
                        -moz-box-sizing: border-box;
                        box-sizing: border-box;
                    }

    .l-link-item-unsel .menu-item-icon {
        color: rgb(177, 177, 177);
    }

    .l-topmenu-welcome {
        /*right: 90px;*/
        right: 50px;
    }

    #LANToPrintBtn .b {
        display: block;
    }

    #LANToPrintBtn.toggle {
        position: absolute;
        top: 50%;
        right: 10px;
        width: 40px;
        height: 20px;
        border-radius: 100px;
        background-color: #ddd;
        margin-top: -10px;
        box-shadow: inset 0 0 2px 1px rgba(0,0,0,.05);
    }

    #LANToPrintBtn {
        display: none;
    }

        #LANToPrintBtn .check {
            position: absolute;
            display: block;
            cursor: pointer;
            top: 0;
            left: 0;
            width: 100%;
            height: 100%;
            opacity: 0;
            z-index: 6;
        }

            #LANToPrintBtn .check:checked ~ .track {
                box-shadow: inset 0 0 0 20px #4bd863;
            }

        #LANToPrintBtn.error .check:checked ~ .track {
            box-shadow: inset 0 0 0 20px #FF9800;
        }

        #LANToPrintBtn .check:checked ~ .switch {
            right: 2px;
            left: 22px;
            transition: .35s cubic-bezier(0.785, 0.135, 0.150, 0.860);
            transition-property: left, right;
            transition-delay: .05s, 0s;
        }

        #LANToPrintBtn .check:checked ~ .toggle-txt-open {
            display: block;
        }

        #LANToPrintBtn .check:checked ~ .toggle-txt-close {
            display: none;
        }

        #LANToPrintBtn .switch {
            position: absolute;
            left: 2px;
            top: 2px;
            bottom: 2px;
            right: 22px;
            background-color: #fff;
            border-radius: 36px;
            z-index: 1;
            transition: .35s cubic-bezier(0.785, 0.135, 0.150, 0.860);
            transition-property: left, right;
            transition-delay: 0s, .05s;
            box-shadow: 0 1px 2px rgba(0,0,0,.2);
        }

        #LANToPrintBtn .track {
            position: absolute;
            left: 0;
            top: 0;
            right: 0;
            bottom: 0;
            transition: .35s cubic-bezier(0.785, 0.135, 0.150, 0.860);
            box-shadow: inset 0 0 0 2px rgba(0,0,0,.05);
            border-radius: 40px;
        }

    .toggle-txt {
        position: absolute;
        top: 0;
        line-height: 22px;
    }

    .toggle-txt-open {
        left: 6px;
        display: none;
        color: #fff;
    }

    .toggle-txt-error {
        left: 6px;
        display: none;
        color: #fff;
    }

    .toggle-txt-close {
        right: 6px;
        color: #000;
    }

    #LANToPrintBtn.error .toggle-txt-open {
        display: none !important;
    }

    #LANToPrintBtn.error .toggle-txt-error {
        display: block;
    }

    .LANinfo {
        position: absolute;
        top: 38px;
        right: 0;
        width: 220px;
        padding: 5px;
        border: 1px solid #ddd;
        background: #fff;
        z-index: 99;
        box-shadow: 0px 0px 10px 0px rgba(0,0,0,0.5);
        line-height: 25px;
        display: none;
    }

        .LANinfo::after {
            content: '';
            position: absolute;
            bottom: 100%;
            right: 7px;
            width: 0;
            height: 0;
            border-width: 9px;
            border-style: solid;
            border-color: transparent;
            border-bottom-width: 18px;
            border-bottom-color: currentColor;
            color: #fff;
        }
    .lan-tips{
        color: #ff7600;
    }
    .lanType {
        color: red;
    }

    .lanType_open {
        color: #4bd863;
    }

    .lanType_error {
        color: #FF9800;
    }

    .localIP {
        color: blue;
        font-weight: bolder;
    }

    .changeFontSize-outer {
        width: 30px;
        position: absolute;
        right: 60px;
        top: 8px;
        cursor: pointer;
        z-index: 99;
        height: 30px;
    }

    .changeFontSize-icon {
        font-size: 24px;
        color: #fff;
        text-align: center;
        line-height: 30px;
    }

    .changeFontSize-inputbox {
        position: absolute;
        right: 0px;
        top: 37px;
        background: #fff;
        width: 270px;
        padding: 5px;
        box-shadow: 1px 1px 8px 1px rgba(0,0,0,0.5);
        display: none;
    }

        .changeFontSize-inputbox input {
            cursor: pointer;
            vertical-align: middle;
        }

        .changeFontSize-inputbox label {
            cursor: pointer;
            vertical-align: middle;
        }

    .changeFontSize-part {
        float: left;
        line-height: 24px;
        margin-right: 10px;
    }

    .changeFontSize-outer:hover .changeFontSize-icon {
        background: #000;
    }

    .gonggao-num {
        float: left;
        line-height: 25px;
        padding: 0 5px;
        color: #139fec;
    }

    .quickSearch-bar {
        position: absolute;
        background: #fff;
        width: 100%;
        left: 0;
        top: 27px;
        z-index: 999;
        border-radius: 3px;
        border: 1px solid #ddd;
        display: none;
        max-height: 400px;
        overflow: auto;
    }

    .quickSearch-item {
        overflow: hidden;
        line-height: 24px;
        cursor: pointer;
    }

        .quickSearch-item:hover {
            background: #adc6e5;
            font-size: 16px;
        }

        .quickSearch-item.currentSel {
            background: #adc6e5;
            font-size: 16px;
        }

    .quickSearch-tit {
        width: 40%;
        float: left;
        text-align: right;
    }

    .quickSearch-val {
        width: 60%;
        float: left;
        text-align: left;
        text-indent: 10px;
        color: #03a9f4;
    }

    .quickSearch-icon {
        position: absolute;
        left: 8px;
        top: 0;
        width: 20px;
        height: 100%;
        line-height: 24px;
        color: #b6b6b6;
        background: none;
        cursor: pointer;
    }

    .quickSearch-listBtn {
        left: auto;
        right: 40px;
        font-size: 20px;
    }

    .quickSearch-settings-box {
        position: absolute;
        left: 0;
        top: 25px;
        z-index: 999;
        width: 220px;
        height: 450px;
        padding: 5px;
        background: #efefef;
        border: 1px solid #ddd;
        box-shadow: 0px 0px 10px 0px rgba(0,0,0,0.5);
        border-radius: 3px;
        display: none;
    }

    .qs-set-left {
        float: left;
        width: 70%;
        height: 90%;
        background: #fff;
        box-shadow: 0px 0px 7px 0px rgba(0,0,0,0.5) inset;
        border-radius: 3px;
        overflow: auto;
    }

    .qs-set-right {
        float: left;
        width: 30%;
        border-left: 1px solid #ddd;
        margin-left: -1px;
        height: 90%;
    }

    .qs-btn {
        color: #666;
        margin: 24px 10px;
        border: 1px solid #ddd;
        border-radius: 3px;
        cursor: pointer;
        box-shadow: 0px 0px 4px 0px rgba(0,0,0,0.5);
    }

        .qs-btn:hover {
            box-shadow: 0px 0px 4px 0px rgba(0,0,0,0.5), 0px 0px 4px 0px rgba(0,0,0,0.5) inset;
        }

    .qs-item {
        text-align: left;
        padding-left: 10px;
        line-height: 24px;
        cursor: pointer;
    }

    .qs-input {
        width: 15px;
        height: 15px;
        position: relative;
        top: 3px;
        cursor: pointer;
    }

        .qs-input:checked ~ .qs-label {
            color: red;
        }

    .qs-label {
        color: #666;
        margin-left: 5px;
        cursor: pointer;
    }

    .qs-item:hover .qs-label {
        color: blue;
    }

    .qs-item.currentSel .qs-label {
        color: blue;
    }

    .qs-title {
        margin-bottom: 5px;
        line-height: 20px;
        font-size: 14px;
    }

        .qs-title span {
            display: block;
            font-size: 12px;
            color: red;
        }

    .ad-banner {
        display: none;
        position: fixed;
        width: 100%;
        height: 100%;
        z-index: 99999;
        top: 0;
        left: 0;
    }
    .swiper-container {
        width: 80%;
        height: 80%;
        position: absolute;
        left: 50%;
        top: 50%;
        transform: translate(-50%, -50%);
        overflow: hidden;
    }

    .app-down-arrow-tip {
        position: absolute;
        top: 140px;
        /* right: 160px; */
        width: 600px;
        height: 360px;
        box-sizing: border-box;
        z-index: 99999;
        background: rgba(0,0,0,.5);
        border: 1px solid #fff;
        border-radius: 8px;        
        color:#fff;
    }
    .lq-arrow-top{
        position: absolute;
        top: -142px;
        left: 460px;
    }
    .lq-arrow-top::before{
        content: '';
        width: 0px;
        height: 0px;
        display: block;
        position: absolute;
        top: 50px;
        left: 0;
        transform: rotate(45deg);
        -ms-transform: rotate(45deg);
        -moz-transform: rotate(45deg);
        -webkit-transform: rotate(45deg);
        -o-transform: rotate(45deg);
        border-top: 12px solid #fff;
        border-right: 12px solid transparent;
        border-left: 12px solid #fff;
        border-bottom: 12px solid transparent;
    }
    .lq-arrow-top::after{
        content: '';
        width: 10px;
        height: 86px;
        display: block;
        position: absolute;
        top: 50px;
        left: 7.2px;
        border-radius: 6px;
        background-color: #fff;
    }
    .lq-tip-content{
        padding: 14px;
    }
    .lq-tip-title{
        font-size: 22px;
    }
    .lq-tip-title i{
        font-size: 22px;
        margin: 0 6px;
    }
    .lq-tip-text{
        text-align: center;
        margin: 40px 0;
        font-size: 20px;
    }
    .lq-tip-customer{
        height: 22px;
        margin: 0 4px;
        vertical-align: middle;
    }
    .lq-tip-p{
        text-align: center;
        height: 26px;
    }
    .lq-tip-bottom{
        text-align: center;
        padding-top: 28px;
    }
    .lq-tip-btn{
        display: inline-block;
        width: 320px;
        border:2px solid #fff;
        border-radius: 8px;
        line-height: 54px;
        margin: 12px 0;
        height: 54px;
        background: #4295cd;
        font-size: 20px;
        font-weight: 600;
        cursor: pointer;
    }
    .lq-tip-bottom-text{
        color: rgba(255,255,255,.5);
    }
    .update-dialog-wraper,
    .app-down-outer,
    .onekeycallcar-outer {
        display:none;
        position: fixed;
        top: 50%;
        left: 50%;
        width: 100%;
        height: 100%;
        transform: translate(-50%, -50%);
        z-index: 99998;
    }
    .update-dialog {
        position: absolute;
        left: 50%;
        top: 50%;
        transform: translate(-50%, -50%);
        width: 310px;
        min-height: 100px;
        background: #F9F9F9;
        border-radius: 4px;
        box-shadow: 0 5px 10px rgba(0,0,0,0.16);
    }
    .update-dialog .header {
        height: 60px;
        border-radius: 5px 5px 0px 0;
        background: #e53935;
    }
    .update-dialog .content {
        padding: 5px;
    }
    .update-dialog .content .title {
        text-align: center;
        font-size: 18px;
    }
    .update-dialog .content .update-box {
        font-size: 14px;
    }
    /* .update-dialog .content .update-box .version {
        @* position: absolute;
        top: 70px;
        right: 90px; *@
    } */
    .update-dialog .footer {
        position: absolute;
        bottom: 0px;
        right: 0;
        width: 100%;
        padding: 5px;
        text-align: right;
        box-sizing: border-box;
    }
    .update-dialog .footer .close {
        display: inline-block;
        padding: 2px 10px;
        font-size: 14px;
        color: #000;
        outline: none;
        border-width: 1px;
        border: 1px solid #D2D2D2;
        border-radius: 3px;
        background-color: white;
        cursor: pointer;
    }

    .update-dialog .footer .close.read {
        color: #0099E5;
    }

    .update-text {
        font-size: 12px;
        color: #666
    }
    .update-box li::before {
        display: inline-block;
        content: "-";
        text-indent: .5rem;
    }
    .ad-banner-btn-notips{
        top: 130px;
    }

    .gif-pic,
    .zxb-msg-bg {
        width: 100%;
        height: auto;
        cursor: pointer;
    }

     .downapp {
        position: relative;
        /* float: left;
        color: #ffff00;
        margin-left: 6px;
        cursor: pointer; */
        z-index: 100000;
    }

    .downappcode {
        display: none;
        position: absolute;
        right: -205px;
        top: 58px;
        width: 750px;
        /* height: 200px; */
        padding-top: 20px;
        background: #fff;
        z-index: 100;
        border-radius: 12px;
        padding-bottom: 20px;
    }

    .downappcode::after {
        content: "";
        width: 0;
        height: 0;
        border: 20px solid;
        position: absolute;
        top: -40px;
        left: 517px;
        border-color: transparent transparent #fff transparent;;
    }
    .miniapp-qrcode {
        width: 120px;
        margin-left: 280px;
        box-shadow: 0 0 10px rgba(0,0,0,0.1);
        font-size: 10px;
        padding: 4px;
    }
    #miniapp-share-img {
        margin-bottom: 15px;
    }
    .contactWayCode {
        display: none;
        position: absolute;
        left: -97px;
        top: 48px;
        width: 242px;
        height: 30px;
        background: #fff;
        z-index: 100;
        border-radius: 4px;
        box-shadow: 1px 0px 7px 1px #e9ebec;
    }
    .contactWayCodeOne{
        display: flex;
        justify-content:space-between;
        padding-left: 5px;
        padding-right: 5px;
    }

    .contactWayCode::after {
        content: "";
        width: 0;
        height: 0;
        border: 16px solid;
        position: absolute;
        top: -28px;
        left: 92px;
        border-color: transparent transparent #fff transparent;
    }

    .un-read-wrap {
        display: none;
        width: 1000px;
        height: 700px;
        position: absolute;
        transform: translate(-50%, -50%);
        top: 50%;
        left: 50%;
    }

    .shopcar {
      float: left;
      margin-top: 2px;
      margin-left: 5px;
      margin-right: 5px;
      cursor: pointer;
    }
    #lq-share-close{
        margin-left: 48px;
    }
    #lq-share-codeimg{
        display: none;
        text-align: center;
        margin-top: 20px;
    }
    #lq-share-codeimg .lq-share-title{
        font-weight: 600;
        font-size: 18px;
        margin-bottom: 8px;
    }
    #lq-share-codeimg #lq-share-box{
        width: 220px;
        height: 220px;
        background: #ccc;
        margin: 0 auto 12px;
        position: relative;
    }
    #lq-share-codeimg #lq-share-img{
        width: 220px;
        height: 220px;
        background: #ccc;
    }
    #lq-share-codeimg #lq-share-empty{
        width: 220px;
        height: 220px;
        background: #ccc;
        position: absolute;
        top:0;
        left: 0;
        display: none;
        line-height: 220px;
        cursor: pointer;
    }
    #lq-share-codeimg #lq-share-empty i {
        margin-right: 2px;
        background: none;
        font-size: 14px;
    }
    #lq-share-codeimg .lq-share-tip{
        margin-bottom: 8px;
    }
    #insuranceBtn{
      width: 630px;
      height: 100px;
      position: absolute;
      right: 20px;
      bottom: 253px;
      cursor: pointer;
    }
    #add-insurance{
      width: 60%;
      margin: 50px auto 20px;   
      line-height: 30px;
    }
    #add-insurance input{
      display: block;
      width: 100%;
      height: 26px;
      font-size: 16px;
      margin-top:20px;
      border-radius: 4px;
      border: 1px solid #999;
      text-indent: 0.3em;  
    }
     #add-insurance .code-input-box{
      position: relative;
    }
    #add-insurance .code-input{
        display: inline-block;
        width: 65%;
    }
    #add-insurance .code-btn{
      width: 100px;
      height: 30px;
      font-size: 16px;
      position: absolute;
      top: 20px;
      right: -4px;
      cursor: pointer;
    }
    #add-insurance .receive-btn{
      width: 100%;
      height: 30px;
      font-size: 16px;
      border-radius: 4px;
      cursor: pointer;
      border: 1px solid #999;
      margin: 30px 0px;
    }
    #add-insurance .receive-btn:hover{
      background:#ff0 ;
    }


  .coupon-tip {
    display: none;
    position: absolute;
    z-index: 10;
    bottom: 27px;
    background: #fff;
    color: #f46234;
    margin: 10px 0px;
    width: 100%;
    height: 320px;
  }
  .menu-item-icon {
      line-height: 30px;
      font-size: 23px;
      color: #fff;
      background: none;
  }
  .menu-item-list{
    display: none;
  }

  .more-menu-item:hover .menu-item-list {
    display: block;
    cursor: pointer;
  }

  .menu-item-list{
    position: absolute;
    top: 12px;
    left: -1px;
    border: 20px solid;
    border-color: transparent transparent #fff transparent;
  }
  .menu-item-list-div {
    position: absolute;
    top: 13px;
    left: -103px;
    width: 191px;
    background: #fff;
    padding: 4px;
    padding-top: 10px;
    border-radius: 8px;
    display: flex;
    align-items: center;
    justify-content: space-around;
    box-shadow: 1px 0px 7px 1px #e9ebec;
  }
</style>
